/**
 * @link https://mui.com/material-ui/react-progress/
 */

import * as React from 'react'
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import {Divider, Typography, Box} from '@mui/material';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeProgressDeterminate() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <Divider textAlign={"left"}><Typography variant={"h6"}>Determinate</Typography></Divider>
      <Stack spacing={2} direction="row" sx={{mb:5}}>
        <CircularProgress variant="determinate" value={25} />
        <CircularProgress variant="determinate" value={50} />
        <CircularProgress variant="determinate" value={75} />
        <CircularProgress variant="determinate" value={100} />
        <CircularProgress variant="determinate" value={progress} />
      </Stack>
      <Box sx={{p:2, mb:3}}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
      
      <ShowCode 
        codeString={`function ProgressDeterminateExample() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <Divider textAlign="left">
        <Typography variant="h6">Determinate</Typography>
      </Divider>
      
      {/* Circular Progress Indicators */}
      <Stack spacing={2} direction="row" sx={{mb: 5}}>
        <CircularProgress variant="determinate" value={25} />
        <CircularProgress variant="determinate" value={50} />
        <CircularProgress variant="determinate" value={75} />
        <CircularProgress variant="determinate" value={100} />
        <CircularProgress variant="determinate" value={progress} />
      </Stack>
      
      {/* Linear Progress Indicator */}
      <Box sx={{p: 2, mb: 3}}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </>
  );
}`} 
        scope={{ 
          React, 
          Stack, 
          CircularProgress, 
          LinearProgress, 
          Divider, 
          Typography, 
          Box 
        }} 
      />
    </>
  );
}
